import { useState, useEffect } from "react";

function useConvsListProgressData({
  listContainerRef,
  selectedConvType,
  pendingConversations,
  ongoingConversations,
  otherOperatorsConversations,
}) {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [remainingItems, setRemainingItems] = useState(0);

  // update remaining items count and scroll progress when scrolling convs list.
  const handleScrollConvsList = () => {
    const listContainer = listContainerRef.current;

    if (listContainer) {
      const scrollPosition = listContainer.scrollTop;
      const totalHeight =
        listContainer.scrollHeight - listContainer.clientHeight;
      const scrollPercentage = (scrollPosition / totalHeight) * 100;
      setScrollProgress(+scrollPercentage.toFixed(0));

      const listItems = document.querySelectorAll("#conversation-item");
      let remainingCount = 0;
      listItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.bottom > window.innerHeight) {
          remainingCount++;
        }
      });

      setRemainingItems(remainingCount);
    }
  };

  // update scroll data(remaining counts & progress) on any changes in convs list.
  useEffect(() => {
    handleScrollConvsList();
  }, [
    selectedConvType,
    pendingConversations,
    ongoingConversations,
    otherOperatorsConversations,
  ]);

  useEffect(() => {
    const listContainer = listContainerRef.current;

    listContainer.addEventListener("scroll", handleScrollConvsList);
    return () => {
      listContainer.removeEventListener("scroll", handleScrollConvsList);
      setRemainingItems(0);
    };
  }, []);

  return [scrollProgress, remainingItems];
}

export default useConvsListProgressData;
